<template>
  <b-container class="mt-2 mb-3 text-center bg-transparent menu">
    <b-row class="justify-content-around text-center">

      <b-col lg="3" md="3" class="pt-3">
        <span class="d-lg-none">
          <b-button v-b-toggle.sidebar-1 class="bg-light text-dark font-weight-bold">منو</b-button>
        </span>
        <span v-if="$store.getters['User/isAuthenticated']">
          <router-link :to="{ name: 'Dashboard' }" class="login-text text-decoration-none text-dark">
            <b-icon class="custom-font-size-person-icon" icon="person"></b-icon>
            حساب کاربری
          </router-link>
        </span>

        <span v-else>
          <router-link :to="{ name: 'Login' }" class="login-text text-decoration-none text-dark">
            ورود/عضویت
          </router-link>
        </span>

        <span v-if="IsAuthenticated || findAttributeOnSiteInfo('cartType') == 1" class="mr-3">
          <span class="badge shopping-cart-counter "
                v-if=" orderCount.length != 0 && orderCount.items != undefined">
            {{ orderCount.items.length }}
          </span>
          <router-link :to="{ name: 'ShoppingCart' }">
            <b-icon class="login-icon" icon="cart"></b-icon>
          </router-link>

        </span>
        <span v-else class="mr-3">
          <span
              class="badge shopping-cart-counter "> {{
              shoppingCartCount
            }}  </span>
          <router-link :to="{ name: 'UnAuthenticatedShoppingCart' }">
            <b-icon class="login-icon" icon="cart" href="#"></b-icon>
          </router-link>
        </span>

      </b-col>


      <b-col lg="6" md="6" sm="12" class="text-center align-items-center p-0 m-0">
        <div align-v="stretch" class="justify-content-center text-center w-100">
          <m-a :href="{ name: 'Home' }" class="text-center w-100 h-100">
            <img :src="findAttributeOnSiteInfo('icon')[0]" class="logo" :alt="findAttributeOnSiteInfo('site_name')[0]"/>
          </m-a>
        </div>
      </b-col>


      <b-col lg="3" md="3" class="align-items-left">
        <m-search-input-2/>
      </b-col>

    </b-row>

    <div align-v="center" class="justify-content-center p-0 d-none d-lg-flex w-100">
      <b-row class="justify-content-center border-top border-dark p-0 pt-3 m-0 mt-3">
        <b-navbar v-for="menu in storeMenus" :key="menu.id" v-if="menu.position==='store_nav'">
          <NavMenuItem col lg="3" v-for="item in menu.children" :item="item" :key="item.id"/>
        </b-navbar>
      </b-row>
    </div>

    <div>
      <b-sidebar id="sidebar-1" shadow backdrop>
        <div class="px-3 py-2" v-for="menu in storeMenus" :key="menu.id" v-if="menu.position==='store_nav'">
          <NavMenuItem col lg="3" v-for="item in menu.children" :item="item" :key="item.id"/>

        </div>
      </b-sidebar>
    </div>
  </b-container>
</template>

<script>
import {mapGetters} from 'vuex';
import NavMenuItem from "./NavMenuItem";

export default {
  name: "Nav101",
  components: {NavMenuItem},
  data() {
    return {
      searchWord: '',
      shoppingCartCount: 0
    }
  },
  methods: {
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
    }
  },
  computed: {
    words: {
      get() {
        return this.searchWord;
      },
      set(searchedWord) {
        this.searchWord = searchedWord
      },
    },
    ...mapGetters({
      orderCount: 'ShoppingCart/getSidebarBasketData',
      storeMenus: "Menu/getStoreMenus",
    }),

    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },

  },
  async mounted() {
    const search = this.$router.currentRoute.query.search;
    if (search != undefined) {
      this.searchWord = search;
    }
    if (this.IsAuthenticated) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid");
    }
    window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);
  },
};
</script>

<style scoped>

.login-text {
  font-size: 15px;
  color: var(--gray-dark);
}

.login-icon {
  font-size: 22px;
  color: var(--gray-dark);
}

.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.shopping-cart-counter {
  font-size: 12px;
  background: var(--red) !important;
  color: var(--light-cyan);
  padding: 0 5px;
  vertical-align: top;
  margin-left: -15px;
  margin-top: 0;
}

.navbar-brand img {
  height: 70px;
}

.menu {
  position: relative;
  top: 0;
  z-index: 100;
}

.logo {
  max-height: 100px !important;
  margin: auto;
}

.custom-font-size-person-icon {
  font-size: 25px
}

</style>